<kendo-formfield orientation="horizontal">
  <kendo-dropdownlist
    [data]="years()"
    [valuePrimitive]="true"
    [(ngModel)]="timetableService.selectedYear"
    (selectionChange)="yearChanged($event)"
  >
  </kendo-dropdownlist>
</kendo-formfield>
